import React from 'react';
import { HealthPlanUser } from '../../../graphql/graphql';
import { HealthPlanTimelineGroup } from '../../../Models/HealthPlan/HealthPlanTimelineGroup';
import Text from '../../Base/Text/Text';
import FormattedDate from '../../FormattedDate';
import Collapse from '../Collapse/Collapse';
// @ts-ignore
import styles from './HealthPlanWrapper.module.scss';
import HealthPlanTimelineContainer from '../../../Modules/HealthPlan/Components/HealthPlanTimelineContainer';

interface HealthPlanWrapperCollapseProps {
	title?: string;
	data: HealthPlanTimelineGroup[];
	patientId: string;
	workplaceId: string;
	allowEdit: boolean;
	showDetails?: boolean;
	showContinue?: boolean;
	healthPlanUser?: HealthPlanUser;
	onSuccess: () => void;
	handleRefreshData: () => Promise<void>;
	handleMonthClick: (item: { shortTitle: any }) => void;
}

const HealthPlanWrapperCollapse: React.FC<HealthPlanWrapperCollapseProps> = ({
	title,
	data,
	patientId,
	workplaceId,
	allowEdit = true,
	showDetails,
	healthPlanUser,
	handleRefreshData,
	handleMonthClick,
}) => {
	const component = (
		<div className={styles.main}>
			{healthPlanUser && (
				<div className={styles.planInfo}>
					<div className={styles.planInfoName}>
						{healthPlanUser?.healthPlan?.name}
					</div>
					<div className={styles.planInfoItem}>
						<Text tx={'base.shared.doctor'} inline firstUpper />:{' '}
						{healthPlanUser?.doctor?.profile?.fullName}
					</div>
					{healthPlanUser?.activatedAt && (
						<div className={styles.planInfoItem}>
							<Text tx={'component.healthPlan.activated'} inline firstUpper />
							: <FormattedDate date={healthPlanUser.activatedAt} />
						</div>
					)}
					{healthPlanUser?.activeTo && (
						<div className={styles.planInfoItem}>
							<Text tx={'component.healthPlan.ending'} inline firstUpper />:{' '}
							<FormattedDate date={healthPlanUser.activeTo} />
						</div>
					)}
					{healthPlanUser?.activatedAt &&
						!healthPlanUser?.healthPlanUserBaby && (
							<div className={styles.planInfoItem}>
								<Text tx={'component.healthPlan.payed'} inline firstUpper />:{' '}
								<FormattedDate date={healthPlanUser.activatedAt} />
							</div>
						)}
					{healthPlanUser?.healthPlanUserBaby?.gestionalAge && (
						<div className={styles.planInfoItem}>
							<Text
								tx={'component.patientMiniProfile.gestationalWeek'}
								inline
								firstUpper
							/>
							: {healthPlanUser.healthPlanUserBaby.gestionalAge}
						</div>
					)}
					{healthPlanUser?.healthPlanUserBaby?.dateOfBirth && (
						<div className={styles.planInfoItem}>
							<Text
								tx={'component.patientMiniProfile.plannedDateOfBirth'}
								inline
								firstUpper
							/>
							:{' '}
							<FormattedDate
								date={healthPlanUser.healthPlanUserBaby.dateOfBirth}
							/>
						</div>
					)}
				</div>
			)}
			<HealthPlanTimelineContainer
				data={data}
				onMonthClick={handleMonthClick}
				patientId={patientId}
				healthPlanUser={healthPlanUser}
				workplaceId={workplaceId}
				reloadData={handleRefreshData}
			/>
		</div>
	);

	if (title) {
		return (
			<Collapse title={title} defaultOpen>
				{component}
			</Collapse>
		);
	}

	return component;
};

export default HealthPlanWrapperCollapse;
